import { render } from "./Faturamento.vue?vue&type=template&id=54720b06"
import script from "./Faturamento.vue?vue&type=script&lang=ts"
export * from "./Faturamento.vue?vue&type=script&lang=ts"
script.render = render

export default script